<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import { onMounted, ref } from 'vue'
import { Icon } from '@iconify/vue'
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue';
import { ItemWidgetsList } from '../contants/item.widgets.list';
import { Skeleton } from 'primevue';
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant';

const widgets = ref(ItemWidgetsList);
const loading = ref(false);
const fetchAnalyticsData = async () => {
  loading.value = true;
  try {
    const res: any = await APIClient.get('/dashboard');
    return res?.data?.data;
  } catch (error) {
    console.error('Error fetching analytics data:', error);
    return {};
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  const res = await fetchAnalyticsData();
  widgets.value.forEach((item: any) => {
    if (res[item.key] !== undefined) {
      item.badgeCount = res[item.key];
    }
  });
});

</script>

<template>
  <dashboard-layout pageTitle="Dashboard" currentRoute="overview">
    <div class="dashboard-content">
      <div class="flex flex-col">
        <div class="w-full md:w-[70vw] mx-[auto] my-5 grid grid-cols-6 gap-[16px]">
          <div v-for="(item, idx) in widgets" :key="`widget-${idx}`">
            <AllowPerm :perm="item.perm" action="hide">
              <div class="dash-board-widget"
                @click="$router.push(item.path)"
              >
                <div class="icon">
                  <Icon :icon="item.icon"/>
                </div>
                <div class="info">
                  {{ item.label }}
                </div>
                <div class="badge-count-loading" v-if="loading">
                  <Skeleton width="16px" height="16px" />
                </div>
                <div class="badge-count" v-if="item.badgeCount > 0 && !loading">
                  {{ item.badgeCount }}
                </div>
              </div>
            </AllowPerm>
          </div>

        </div>
      </div>
    </div>
  </dashboard-layout>
</template>

<style scoped>

</style>
